
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Kiacarenceonrentmumbai() {



    const cardData =
    {
        keyword: ' Kia Carens On Rent in Mumbai',
        heading: 'Skyline Cabs: Kia Carens On Rent in Mumbai ',
        headingDescription: 'Skyline Cabs offers comfortable and reliable Kia Carens on Rent in Mumbai services for a premium travel experience. Whether you are planning a family outing, corporate trip, or a special event, our well-maintained Kia Carens vehicles and professional drivers ensure a smooth and enjoyable ride. Enjoy door-to-door pickups from anywhere in Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your Kia Carens rental with Skyline Cabs today and travel in style and comfort across Maharashtra and beyond!',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Kia Carens on Rent in Mumbai",
      "description": "Skyline Cabs offers Kia Carens on rent in Mumbai, perfect for comfortable and stylish travel around the city or for outstation trips."
    },
    {
      "name": "Rent Kia Carens for Outstation",
      "description": "Planning an outstation journey? Rent a Kia Carens from Skyline Cabs for a smooth and spacious travel experience with modern features."
    },
    {
      "name": "Mumbai Kia Carens Rental",
      "description": "Skyline Cabs provides reliable Kia Carens rental services in Mumbai. Ideal for families, group trips, and executive travel."
    },
    {
      "name": "7 Seater Kia Carens Hire Mumbai",
      "description": "Hire a 7-seater Kia Carens in Mumbai with Skyline Cabs. Enjoy spacious interiors and a premium ride for your family or group travel."
    },
    {
      "name": "Mumbai Car Rental Kia Carens",
      "description": "Book Kia Carens through Skyline Cabs’ Mumbai car rental services. Flexible packages and easy booking for your convenience."
    },
    {
      "name": "Kia Carens for Corporate Events",
      "description": "Make a great impression at your corporate events with Kia Carens rentals from Skyline Cabs. Comfortable, professional, and reliable transport."
    }
  ],
  "tableData": [
    ["Kia Carens on Rent in Mumbai", "Rent Kia Carens for Outstation"],
    ["Mumbai Kia Carens Rental", "7 Seater Kia Carens Hire Mumbai"],
    ["Mumbai Car Rental Kia Carens", "Kia Carens for Corporate Events"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Kia Carens on Rent in Mumbai",
      "WhyChoosedescription": "Rent the stylish and comfortable Kia Carens in Mumbai for your next family trip, business travel, or leisure outing. Perfect for long drives, city tours, and airport transfers."
    },
    {
      "WhyChooseheading": "Spacious and Luxurious Interiors",
      "WhyChoosedescription": "The Kia Carens offers a spacious 7-seater configuration with luxurious seating, ample legroom, and modern amenities, ensuring a comfortable ride for all passengers."
    },
    {
      "WhyChooseheading": "Ideal for Family and Group Travel",
      "WhyChoosedescription": "Whether it’s a family holiday, a group outing, or a business trip, the Kia Carens provides the perfect combination of comfort, space, and style for your travels in and around Mumbai."
    },
    {
      "WhyChooseheading": "Advanced Features and Smooth Drive",
      "WhyChoosedescription": "Equipped with advanced safety features, a premium infotainment system, air conditioning, and smooth driving capabilities, the Kia Carens ensures a top-notch travel experience."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our skilled and courteous drivers ensure that you travel safely and comfortably while respecting your time and preferences for a smooth journey."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
      "WhyChoosedescription": "Every Kia Carens is regularly cleaned and sanitized, with routine maintenance to guarantee a hygienic, safe, and reliable ride every time you book."
    },
    {
      "WhyChooseheading": "Flexible Rental Packages",
      "WhyChoosedescription": "Choose from hourly, daily, or extended rental packages, tailored to fit your travel plans, whether it's a short city ride or an extended road trip."
    },
    {
      "WhyChooseheading": "24/7 Easy Booking and Customer Support",
      "WhyChoosedescription": "Booking the Kia Carens is easy through our online platform or by phone. Our 24/7 customer support team ensures a seamless booking experience and assistance whenever you need it."
    }
  ]
  
  
  
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent a Kia Carens in Mumbai with Skyline Cabs?',
            answer:
                'Renting a Kia Carens in Mumbai is simple. You can book via our website, mobile app, or by contacting our customer support. Just provide your pickup location, date, and travel details to get started.',
        },
        {
            id: 2,
            question: 'How many passengers can the Kia Carens accommodate?',
            answer:
                'The Kia Carens can comfortably seat 6 to 7 passengers, making it a great choice for family trips, corporate travel, or group outings.',
        },
        {
            id: 3,
            question: 'Is the Kia Carens suitable for long-distance travel?',
            answer:
                'Yes, the Kia Carens is perfect for both city and long-distance travel. It offers a smooth, comfortable ride with spacious interiors, ideal for long road trips and outstation journeys.',
        },
        {
            id: 4,
            question: 'Are the rental prices for Kia Carens in Mumbai fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing for Kia Carens rentals. The fare includes the vehicle, driver charges, fuel, tolls, taxes, and any applicable service fees. You’ll know the total cost before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I rent the Kia Carens for hourly, half-day, or full-day use?',
            answer:
                'Yes, you can rent the Kia Carens for hourly, half-day, or full-day use, depending on your travel needs. We offer flexible rental packages that can be customized based on your trip.',
        },
        {
            id: 6,
            question: 'Is the Kia Carens air-conditioned and comfortable?',
            answer:
                'Yes, all our Kia Carens vehicles are air-conditioned, well-maintained, and equipped with modern amenities for a comfortable journey.',
        },
        {
            id: 7,
            question: 'Can I rent the Kia Carens for corporate or event travel?',
            answer:
                'Yes, the Kia Carens is an excellent choice for corporate transfers, group events, or even weddings. We offer professional drivers and a seamless experience for your special occasions.',
        },
        {
            id: 8,
            question: 'What payment options are available for renting a Kia Carens?',
            answer:
                'We accept payments through UPI, credit/debit cards, net banking, and cash. All online payments are secure and processed through trusted payment gateways.',
        },
        {
            id: 9,
            question: 'Can I modify or cancel my Kia Carens booking?',
            answer:
                'Yes, you can modify or cancel your Kia Carens booking easily via our website, mobile app, or by contacting our customer support. We provide flexible cancellation policies to accommodate changes in your plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Kia Carens rental in Mumbai?',
            answer:
                'Skyline Cabs offers a reliable, comfortable, and cost-effective Kia Carens rental service. With professional drivers, transparent pricing, and excellent customer support, we ensure a hassle-free experience.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Anand Patel",
            rating: 5,
            review: "Rented the Kia Carens for a family road trip to Alibaug. The car was very spacious, clean, and comfortable for our group. The driver was professional, and we had a smooth journey. Highly recommend Skyline Cabs!"
        },
        {
            name: "Ms. Shalini Desai",
            rating: 4,
            review: "Booked a Kia Carens for a weekend trip to Nashik. The car was fantastic—very comfortable and perfect for our group. The only minor issue was a slight delay in the driver’s arrival, but everything else was great!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens On Rent in Mumbai",
  "image": "https://skylinecabs.com/assets/images/kia-carens-on-rent-mumbai.jpg",
  "description": "Book Kia Carens on rent in Mumbai with Skyline Cabs for a stylish and comfortable ride. Ideal for family trips, airport transfers, corporate travel, or long-distance journeys. Enjoy spacious interiors, AC, and experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7993"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/kia-carens-on-rent-in-mumbai"
  }
};

      
    
      


    return (
        <div>


<Helmet>
  <title>Kia Carens On Rent in Mumbai | 6,7 Seater MPV Cab | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Kia Carens on rent in Mumbai with Skyline Cabs for a stylish and comfortable ride. Ideal for family trips, airport transfers, corporate travel, or long-distance journeys. Enjoy spacious interiors, AC, and experienced drivers." 
  />
  <meta 
    name="keywords" 
    content="Kia Carens On Rent in Mumbai, 6 Seater Kia Carens Cab Mumbai, 7 Seater MPV on Hire, Kia Carens for Outstation Mumbai, Airport Kia Carens Cab, Corporate Kia Carens Booking, AC MPV Rental Mumbai, Skyline Cabs Kia Carens Hire" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/94.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kiacarenceonrentmumbai;